(() => {
  if (window.__mhSaleEffect2026) return;
  window.__mhSaleEffect2026 = true;

  const ensureLiveSaleCardStyle = () => {
    if (document.getElementById('mh-live-sale-card-style')) return;

    const style = document.createElement('style');
    style.id = 'mh-live-sale-card-style';
    style.textContent = `
      body.ma-hawa-aqua-ui .ma-hawa-card.has-mahawa-sale {
        border: 1.5px solid rgba(224, 74, 88, .58) !important;
        background: rgba(255, 255, 255, .97) !important;
        box-shadow: 0 0 0 1px rgba(224, 74, 88, .10), 0 .9rem 2.5rem rgba(174, 34, 55, .10) !important;
      }

      body.ma-hawa-aqua-ui .ma-hawa-card.has-mahawa-sale .ma-hawa-card__media {
        border-color: rgba(224, 74, 88, .08) !important;
        background: linear-gradient(145deg, #ffffff, #fbfbfb) !important;
        box-shadow: none !important;
      }

      body.ma-hawa-aqua-ui .ma-hawa-card.has-mahawa-sale .ma-hawa-card__body,
      body.ma-hawa-aqua-ui .ma-hawa-card.has-mahawa-sale .ma-hawa-card__content {
        background: transparent !important;
      }

      body.ma-hawa-aqua-ui .ma-hawa-card__sale-badge {
        border: 1px solid rgba(255, 255, 255, .78) !important;
        color: #ffffff !important;
        background: linear-gradient(135deg, #ef6973, #d94f57 55%, #b92f43) !important;
        box-shadow: 0 .5rem 1.4rem rgba(174, 34, 55, .30) !important;
        text-shadow: none !important;
      }

      body.ma-hawa-aqua-ui .ma-hawa-card__sale-badge::after {
        content: '' !important;
        display: block !important;
        position: absolute !important;
        inset-block: -70% !important;
        inset-inline-start: -60%;
        width: 38% !important;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, .88), transparent) !important;
        transform: skewX(-20deg) !important;
        animation: mh-sale-shine 5.8s ease-in-out infinite !important;
        pointer-events: none !important;
      }

      body.ma-hawa-aqua-ui .ma-hawa-card__sale-info {
        display: grid;
        align-content: end;
        min-width: 0;
        gap: .18rem;
      }

      body.ma-hawa-aqua-ui .ma-hawa-card__sale-info > .ma-hawa-card__price {
        width: 100%;
        min-width: 0;
        margin: 0 !important;
      }

      body.ma-hawa-aqua-ui .ma-hawa-card__sale-meta-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: .55rem;
        width: 100%;
        min-width: 0;
        min-height: 1.35rem;
        margin: 0;
      }

      body.ma-hawa-aqua-ui .ma-hawa-card__sale-meta-row[hidden] {
        display: none !important;
      }

      body.ma-hawa-aqua-ui .ma-hawa-card__sale-meta-row .ma-hawa-card__rating {
        flex: 0 0 auto;
        min-height: 0 !important;
        margin: 0 !important;
        font-size: .86rem !important;
        line-height: 1.1;
        white-space: nowrap;
      }

      body.ma-hawa-aqua-ui .ma-hawa-card__sale-meta-row .ma-hawa-card__sale-savings {
        display: inline-block;
        flex: 0 1 auto;
        width: auto !important;
        min-width: 0;
        margin: 0;
        overflow: hidden;
        color: #b72f43;
        font-size: .76rem !important;
        line-height: 1.15;
        text-align: end;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      @media screen and (max-width: 749px) {
        body.ma-hawa-aqua-ui .ma-hawa-card__sale-info {
          gap: .08rem;
        }

        body.ma-hawa-aqua-ui .ma-hawa-card__sale-info > .ma-hawa-card__price {
          min-height: 0 !important;
        }

        body.ma-hawa-aqua-ui .ma-hawa-card__sale-meta-row {
          min-height: 1.2rem;
          gap: .35rem;
        }

        body.ma-hawa-aqua-ui .ma-hawa-card__sale-meta-row .ma-hawa-card__rating {
          font-size: .8rem !important;
        }

        body.ma-hawa-aqua-ui .ma-hawa-card__sale-meta-row .ma-hawa-card__sale-savings {
          font-size: .7rem !important;
        }
      }

      @keyframes mh-sale-shine {
        0%, 69% { inset-inline-start: -60%; }
        87%, 100% { inset-inline-start: 140%; }
      }

      @media (hover: hover) {
        body.ma-hawa-aqua-ui .ma-hawa-card.has-mahawa-sale:hover {
          border-color: rgba(224, 74, 88, .76) !important;
          background: #ffffff !important;
          box-shadow: 0 0 0 1px rgba(224, 74, 88, .15), 0 1.2rem 3rem rgba(174, 34, 55, .13) !important;
        }
      }

      @media (prefers-reduced-motion: reduce) {
        body.ma-hawa-aqua-ui .ma-hawa-card__sale-badge::after {
          animation: none !important;
        }
      }
    `;
    document.head.append(style);
  };

  ensureLiveSaleCardStyle();

  const normalizeLocale = (value) => String(value || 'en-AE').toLowerCase();
  const isArabic = (locale) => normalizeLocale(locale).startsWith('ar');

  const parseMoney = (value) => {
    const text = String(value || '')
      .replace(/[٠-٩]/g, (digit) => '٠١٢٣٤٥٦٧٨٩'.indexOf(digit))
      .replace(/[۰-۹]/g, (digit) => '۰۱۲۳۴۵۶۷۸۹'.indexOf(digit))
      .replace(/٫/g, '.')
      .replace(/٬/g, ',');
    const matches = text.match(/\d[\d,]*(?:\.\d+)?/g);
    return matches ? Number(matches.at(-1).replace(/,/g, '')) : NaN;
  };

  const formatMoney = (value, locale) => new Intl.NumberFormat(
    isArabic(locale) ? 'ar-AE' : 'en-AE',
    { minimumFractionDigits: 2, maximumFractionDigits: 2 }
  ).format(value);

  const usableTemplate = (value, token, fallback) => {
    const text = String(value || '').trim();
    if (!text || /^translation missing:/i.test(text) || !text.includes(token)) return fallback;
    return text;
  };

  const ensureCompactMeta = (card, priceBox, saving) => {
    const purchase = priceBox.closest('.ma-hawa-card__purchase');
    if (!purchase) return { row: null, rating: null };

    let info = purchase.querySelector('.ma-hawa-card__sale-info');
    if (!info) {
      info = document.createElement('div');
      info.className = 'ma-hawa-card__sale-info';
      purchase.insertBefore(info, priceBox);
      info.append(priceBox);
    } else if (priceBox.parentElement !== info) {
      info.prepend(priceBox);
    }

    let row = info.querySelector('.ma-hawa-card__sale-meta-row');
    if (!row) {
      row = document.createElement('div');
      row.className = 'ma-hawa-card__sale-meta-row';
      info.append(row);
    }

    const rating = card.querySelector('.ma-hawa-card__rating');
    if (rating && rating.parentElement !== row) row.prepend(rating);
    if (saving.parentElement !== row) row.append(saving);

    return { row, rating };
  };

  const updateCard = (card) => {
    if (!card) return;

    const price = card.querySelector('[data-price]');
    const compare = card.querySelector('[data-compare-price]');
    const media = card.querySelector('.ma-hawa-card__media');
    const priceBox = card.querySelector('.ma-hawa-card__price');
    if (!price || !compare || !media || !priceBox) return;

    const shop = card.closest('ma-hawa-shop, [data-sale-badge-template]');
    const locale = shop?.dataset.locale || document.documentElement.lang || 'en-AE';
    const badgeTemplate = usableTemplate(
      shop?.dataset.saleBadgeTemplate,
      '[percent]',
      isArabic(locale) ? 'خصم [percent]%' : '[percent]% OFF'
    );
    const savingsTemplate = usableTemplate(
      shop?.dataset.saleSavingsTemplate,
      '[amount]',
      isArabic(locale) ? 'وفّرت [amount] د.إ' : 'You save AED [amount]'
    );

    const current = parseMoney(price.textContent);
    const original = parseMoney(compare.textContent);
    const active = !compare.hidden
      && Number.isFinite(current)
      && Number.isFinite(original)
      && original > current;

    let badge = media.querySelector('[data-mh-sale]');
    let saving = card.querySelector('[data-mh-save]');

    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'ma-hawa-card__sale-badge';
      badge.dataset.mhSale = '';
      badge.innerHTML = '<span aria-hidden="true">✦</span><span></span>';
      media.append(badge);
    }

    if (!saving) {
      saving = document.createElement('span');
      saving.className = 'ma-hawa-card__sale-savings';
      saving.dataset.mhSave = '';
    }

    const compactMeta = ensureCompactMeta(card, priceBox, saving);

    card.classList.toggle('has-mahawa-sale', active);
    badge.hidden = !active;
    saving.hidden = !active;
    if (compactMeta.row) compactMeta.row.hidden = !compactMeta.rating && !active;
    if (!active) return;

    const percent = Math.round(((original - current) * 100) / original);
    const amount = original - current;
    const badgeText = badgeTemplate.replace('[percent]', String(percent));
    const savingText = savingsTemplate.replace('[amount]', formatMoney(amount, locale));
    const badgeLabel = badge.lastElementChild;

    if (badgeLabel.textContent !== badgeText) badgeLabel.textContent = badgeText;
    if (badge.getAttribute('aria-label') !== badgeText) badge.setAttribute('aria-label', badgeText);
    if (saving.textContent !== savingText) saving.textContent = savingText;
  };

  const pendingCards = new Set();
  let frame = 0;

  const queueCard = (card) => {
    if (!card) return;
    pendingCards.add(card);
    if (frame) return;
    frame = requestAnimationFrame(() => {
      pendingCards.forEach(updateCard);
      pendingCards.clear();
      frame = 0;
    });
  };

  const updateAll = (scope = document) => {
    if (scope.matches?.('.ma-hawa-card')) queueCard(scope);
    scope.querySelectorAll?.('.ma-hawa-card').forEach(queueCard);
  };

  const start = () => {
    updateAll();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        const element = mutation.target.nodeType === Node.ELEMENT_NODE
          ? mutation.target
          : mutation.target.parentElement;
        queueCard(element?.closest?.('.ma-hawa-card'));

        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) updateAll(node);
        });
      });
    });

    observer.observe(document.documentElement, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['hidden']
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('change', (event) => {
    const card = event.target.closest?.('.ma-hawa-card');
    if (card) queueCard(card);
  });
  document.addEventListener('shopify:section:load', (event) => updateAll(event.target));
  window.addEventListener('pageshow', () => updateAll());
})();
